export default "__VITE_ASSET__MTvS$$7z__"